module.exports = __webpack_public_path__ + "img/wechat.113b931a.jpg";